<template>
    <b-modal :title="titolo" ref="mdlAccettazioneSettingLivello" id="mdlAccettazioneSettingLivello" ok-title="salva" @ok="onOk">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label>{{ getLabelTraduora("nurity.accettazione.setting") }}</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idRsaSetting" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="idRsaSettings" text-field="setting" :options="settingsPresidiOptions" @change="onChangeSettingCodice" :disabled="isConclusione">
                    <!--     <template #first>
                        <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                    </template> -->
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label>Livello</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idSettingLivello" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="descrizione" :options="settingLivelliOptions" @change="onChangeRsaSettingLivelli" :disabled="isConclusione"> </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Data e ora inizio:</label>
                <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime" v-model="jsonData.dataOraInizio" :disabled="isConclusione"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Data e ora fine:</label>
                <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" type="datetime" v-model="jsonData.dataOraFine" :disabled="tipo === 'NUOVO'"></date-picker>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    mixins: [UtilityMixin],
    components: { DatePicker },
    data() {
        return {
            pathResource: "/accettazionersasettinglivelli",
            pathResourceSetting: "/rsasettingspresidi",
            pathResourceSettingLivelli: "/rsasettinglivelli",
            titolo: "",
            jsonData: { id: null, idRsaSetting: null, idSettingLivello: null, dataOraInizio: null, dataOraFine: null },
            settingsPresidiOptions: [],
            settingLivelliOptions: [{ id: null, descrizione: "- Seleziona Valore -" }],
            id: null,
            isConclusione: false,
            tipo: null,
        };
    },
    methods: {
        show(item = null, accettazione, tipo) {
            let me = this;
            me.idPresidio = accettazione.idPresidio;
            me.tipo = tipo;
            me.isConclusione = tipo === "CHIUSURA";
            if (item) {
                me.id = item.id;
                me.loadData();
            } else {
                me.loadDataSetting();
                me.jsonData = { id: null, idRsaSetting: null, idSettingLivello: null, dataOraInizio: new Date().getTime(), dataOraFine: null, idAccettazione: accettazione.id };
            }
            this.$refs.mdlAccettazioneSettingLivello.show();
        },
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, null);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            if (me.isConclusione) {
                me.jsonData.dataOraFine = new Date().getTime();
            }
            me.loadDataSetting();
            me.loadDataSettingLivelli(me.jsonData.idRsaSetting);
        },
        loadDataSetting() {
            let me = this;
            me.loadDataResources(me.pathResourceSetting, { idPresidio: me.idPresidio }, me.loadDataSettingSuccess, null);
        },
        loadDataSettingSuccess(response) {
            let me = this;
            me.settingsPresidiOptions = response.data.data.list;
            me.settingsPresidiOptions.unshift({ idRsaSettings: null, setting: "- Seleziona Valore -" });
        },
        salvaAccettazioneSettingLivello() {
            let me = this;
            let pathResource = me.tipo === "CHIUSURA" ? me.pathResource + "/chiusura" : me.pathResource;
            me.saveResource(pathResource, me.jsonData, me.salvaAccettazioneSettingLivelloSuccess, me.salvaAccettazioneSettingLivelloError);
        },
        salvaAccettazioneSettingLivelloSuccess() {
            let me = this;
            me.$bvToast.toast("Aggiornamento avvenuto con succedsso ", {
                title: "Elemento Associato",
                variant: "success",
                solid: true,
            });
            me.$emit("afterSave");
            me.closeModal();
        },
        salvaAccettazioneSettingLivelloError(error) {
            let me = this;
            me.allSavedSuccess = false;
            let messaggio = error.response ? error.response.data.messaggio : error.message;
            me.$bvToast.toast("Errore nell'aggiornamento " + messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.closeModal();
        },
        closeModal() {
            this.$refs.mdlAccettazioneSettingLivello.hide();
        },
        onOk(bvModalEvent) {
            bvModalEvent.preventDefault();
            this.salvaAccettazioneSettingLivello();
        },
        loadDataSettingLivelli(idSetting) {
            let me = this;
            me.loadDataResources(me.pathResourceSettingLivelli, { idSetting: idSetting }, me.loadDataSettingLivelliSuccess, null);
        },
        loadDataSettingLivelliSuccess(response) {
            let me = this;
            me.settingLivelliOptions = response.data.data.list;
            me.settingLivelliOptions.unshift({ id: null, descrizione: "- Seleziona Valore -" });
        },
        onChangeRsaSettingLivelli(value) {
            let me = this;
            me.settingLivelliOptions.forEach((element) => {
                if (element.id === value) {
                    me.jsonData.descrizioneLivello = element.descrizione;
                }
            });
        },
        onChangeSettingCodice(value) {
            let me = this;
            me.settingsPresidiOptions.forEach((element) => {
                if (element.idRsaSettings === value) {
                    me.jsonData.descrizioneSetting = element.setting;
                    //me.jsonData.idSetting = element.idRsaSettings;
                    me.loadDataSettingLivelli(element.idRsaSettings);
                }
            });
        },
    },
};
</script>

<style></style>
